import { render } from "./SelectBookmark.vue?vue&type=template&id=461ec212&ts=true"
import script from "./SelectBookmark.vue?vue&type=script&lang=ts"
export * from "./SelectBookmark.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__